module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Light.ba410ff8.ttf";